export const queryKeys = {
    projects:'projects',
    jobs: 'jobs',
    materials: 'materials'
};